<template>
	<transition name="pop-fade">
		<div class="loadingMask pop-fade-container" v-show="visiable">
			<div class="loadingSpinner">
				<svg viewBox="25 25 50 50" class="circular">
					<circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
				</svg>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			visiable: false
		}
	},
}
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
@import "~@/scss/transition.scss";
.loadingMask {
	z-index: 2000;
	@include mask-container($fullscreen: true);
	.loadingSpinner {
		top: 50%;
		margin-top: px2rem(-40);
		width: 100%;
		text-align: center;
		position: absolute;
		.circular {
			@include square(80);
			animation: loading-rotate 2s linear infinite;
			.path {
				animation: loading-dash 1.5s ease-in-out infinite;
				stroke-dasharray: 90, 150;
				stroke-dashoffset: 0;
				stroke-width: 2;
				stroke: #409eff;
				stroke-linecap: round;
			}
		}
	}
}

@keyframes loading-rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes loading-dash {
	0% {
		stroke-dasharray: 1, 200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -40px;
	}
	100% {
		stroke-dasharray: 90, 150;
		stroke-dashoffset: -120px;
	}
}
</style>
